export enum BasketParkingOptionProperty {
  ParkingDate = 'parkingDate',
  ParkingReason = 'parkingReason',
}

export type BasketParkingOptions = {
  [key in BasketParkingOptionProperty]?: string;
};
